<template>
  <div class="main">
    <div class="banner">
      <h3 class="banner-title">慢病管理解决方案</h3>
      <p class="banner-desc">帮助慢病顾客改善服药依从性，改善生活型态，改善疗效，减少并发症；提升会员粘度和光顾频次；提升药房专业服务力，塑造药房专业形象</p>
      <router-link class="banner-btn" to="/try">申请使用</router-link>
    </div>

    <div class="case">
      <div class="case-container w">
        <div class="m-title">
          <h2>客户案例</h2>
          <p>CUSTOMER CASE</p>
        </div>
        <ul class="case-list">
          <li class="case-item">
            <router-link :to="{ path: 'detail', query: { id: 0 }}">
              <img class="case-pic" src="~@/assets/imgs/case_jianzhijia.png" alt />
              <h3 class="case-title">云南健之佳健康药房</h3>
              <p class="case-desc">
                健之佳药房目前在全国有1000多家门店，有400多万会员。健之佳一直致力于开展专业化药事服务。2015年5月，厚科云健康科技有限公司与云南健之佳连锁药房联手打造医药行业内第一个通过软件系统，连锁企业，品牌厂商一起参与的慢病管理解决方案。目前，云南健之佳已超过900家门店实施慢病管理，服务的慢病会员超过10万，为健之佳在2015-2016连续两年蝉联中国药品零售业综合竞争力专业力冠军，奠定了重要的基础。
                慢病管理的成功落地，不仅帮助健之佳巩固其专业服务竞争力。两年来，随着服务慢病会员人数的增加，健之佳的慢病药品和关联的营养保健品、中药养生、医疗器械的销售都有大幅增长。
              </p>
            </router-link>
          </li>
          <li class="case-item">
            <router-link :to="{ path: 'detail', query: { id: 1 }}">
              <img class="case-pic" src="~@/assets/imgs/case_jiuzhou.png" alt />
              <h3 class="case-title">杭州九洲大药房</h3>
              <p class="case-desc">
                杭州九洲大药房，拥有70家实体药店以及网上药店，2010年4月在美国纳斯达克上市。2015年九洲大药房开始探索药房糖尿病慢病管理，与糖尿病会员建立了很好的关系，顾客粘度非常高，但是一直处于手工操作阶段，扩展和管理瓶颈逐渐显现。
                2016年底厚科云与九洲大药房达成合作，建立标准化慢病管理作业流程，并逐渐扩展到糖尿病、高血压、骨质疏松症等更全面的慢病管理，大大提升了慢病管家的服务效率，让他们更加专注地与会员沟通和交流，总部管理效率也得以大幅提升。
              </p>
            </router-link>
          </li>
          <li class="case-item">
            <router-link :to="{ path: 'detail', query: { id: 2 }}">
              <img class="case-pic" src="~@/assets/imgs/case_haitang.png" alt />
              <h3 class="case-title">海棠药堂</h3>
              <p
                class="case-desc"
              >四川海棠医药有限公司成立于2001年，公司2013年在四川乐山高新区斥资3.8亿新建100亩医药科技产业园，该园集现代化立体库房、仓储物流及住宿餐饮会议等等配套设施，打造西南地区最大的医药、食品、保健品、医疗器械物流配送中心,是四川省乐山市排名第一的医药连锁企业，拥有100多家直营连锁药房，分布在乐山市及各区县。</p>
            </router-link>
          </li>
          <li class="case-item">
            <router-link :to="{ path: 'detail', query: { id: 3 }}">
              <img class="case-pic" src="~@/assets/imgs/case_kangmei.png" alt />
              <h3 class="case-title">康美药业</h3>
              <p
                class="case-desc"
              >康美药业股份有限公司（600518）成立于1997年，于2001年在上交所上市，是国内率先把互联网布局中医药全产业链，全面打造“大健康+大平台+大数据+大服务”体系的中医药全产业链精准服务型“智慧+”大健康产业大型上市企业，国家高新技术企业。位列中国企业500强、全球企业2000强、广东纳税百强，是上证50成份指数股，也是国内资本市场率先突破千亿市值的医药企业。</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- <div class="evaluate">
      <div class="evaluate-container w">
        <div class="m-title">
          <h2>客户评价</h2>
          <p>CUSTOMER EVALUATION</p>
        </div>
        <div class="evaluate-swiper">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide>Slide 1</swiper-slide>
            <swiper-slide>Slide 2</swiper-slide>
            <swiper-slide>Slide 3</swiper-slide>
            <swiper-slide>Slide 4</swiper-slide>
            <swiper-slide>Slide 5</swiper-slide>
          </swiper>

          <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
export default {
  name: "carrousel",
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // 循环
        loop: true
        // Some Swiper option/callback...
      }
    };
  },
  mounted() {
    document.querySelector("body").setAttribute("style", "background:#f4f5f6");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  }
};
</script>
<style lang='scss' scoped>
.banner {
  width: 100%;
  height: 752px;
  background: #f29b33 url("../../assets/imgs/m_banner_bg.png") no-repeat top
    center / 100%;
  padding: 170px 0;
  .banner-title {
    font-size: 64px;
    color: #fff;
    line-height: 90px;
    text-align: center;
    font-weight: 400;
  }
  .banner-desc {
    width: 650px;
    margin: 48px auto 68px;
    font-size: 30px;
    color: #fff;
    line-height: 58px;
  }
  .banner-btn {
    display: block;
    margin: 0 auto;
    width: 192px;
    height: 64px;
    background: #fff;
    border-radius: 4px;
    color: #f08300;
    font-size: 32px;
    text-align: center;
    line-height: 64px;
  }
}

.case {
  width: 100%;
  padding: 88px 0 72px;
  .case-list {
    .case-item {
      width: 686px;
      box-shadow: 0px 30px 40px 0px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      background: #fff;
      margin: 0 auto 32px;
      padding-bottom: 80px;
      & > a {
        display: block;
        width: 100%;
        height: 100%;
      }
      .case-pic {
        width: 100%;
        height: 396px;
      }

      .case-title {
        margin-top: 48px;
        padding: 0 48px;
        font-size: 42px;
        font-weight: bold;
        color: #2f393f;
        line-height: 58px;
      }
      .case-desc {
        margin-top: 24px;
        padding: 0 48px;
        font-size: 28px;
        color: #8a857d;
        line-height: 50px;
        @include ellipsis(4);
      }
    }
  }
}

.evaluate {
  padding: 58px 0 200px;
  background: rgba(240, 131, 0, 0.85);
  .m-title {
    margin-bottom: 58px;
    h2 {
      color: #fff;
    }
    p {
      color: #fff;
      &::after {
        background: #fff;
      }
    }
  }
  .evaluate-swiper {
    margin: 0 auto;
    position: relative;
    .swiper-container {
      width: 606px;
      height: 600px;
      .swiper-slide {
        background: #fff;
      }
    }
    .swiper-pagination {
      width: 100%;
      margin-top: 48px;
      & /deep/ .swiper-pagination-bullet {
        background: #fff;
        opacity: 0.24;
        margin-right: 36px;
      }
      & /deep/ .swiper-pagination-bullet-active {
        opacity: 1;
      }
    }
  }
}
</style>
